export default "__VITE_ASSET__DMjJAjku__"